import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import { Form } from "react-bootstrap";

function parseYMDToLocalDate(s) {
    if (!s || typeof s !== "string") return null;
    const parts = s.split("-").map(Number);
    const [y, m, d] = parts;
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
}

function localDateToYMD(d) {
    if (!d || Number.isNaN(d.getTime())) return "";
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
}

const DatePickerInput = forwardRef(function DatePickerInput(
    { value, onClick, onChange, size, disabled, className, ...rest },
    ref
) {
    return (
        <Form.Control
            ref={ref}
            value={value}
            onClick={onClick}
            onChange={onChange}
            size={size}
            disabled={disabled}
            className={className}
            autoComplete="off"
            {...rest}
        />
    );
});

/**
 * Дата у форматі YYYY-MM-DD (локальний календар), українська локаль react-datepicker,
 * клік по всьому полю відкриває календар.
 * Без `size` — стандартна висота Bootstrap (~як поля на сторінці «Замовлення»); для щільних форм передайте size="sm".
 */
export function AppDateField({
    value,
    onChange,
    size,
    disabled,
    className,
    minDate,
    maxDate,
    popperClassName,
    ...rest
}) {
    return (
        <DatePicker
            locale="uk"
            dateFormat="dd.MM.yyyy"
            selected={parseYMDToLocalDate(value)}
            onChange={(d) => onChange(d ? localDateToYMD(d) : "")}
            customInput={<DatePickerInput size={size} disabled={disabled} className={className} />}
            minDate={minDate ? parseYMDToLocalDate(minDate) : undefined}
            maxDate={maxDate ? parseYMDToLocalDate(maxDate) : undefined}
            popperClassName={popperClassName}
            {...rest}
        />
    );
}
